import comp, { LabelComponent } from "./LabelComponent";
export default comp;
export { LabelComponent };
